<template>
  <div class="personal_center_header">
    <div class="main">
      <div class="main_l">
        <ul>
          <li :class="{ active: $route.path.indexOf('/personal_center/contestant') !== -1 }">
            <router-link to="/personal_center/contestant">参赛选手</router-link>
          </li>
          <li :class="{ active: $route.path.indexOf('/personal_center/unit') !== -1  }">
            <router-link to="/personal_center/unit">推荐单位</router-link>
          </li>
          <li :class="{ active: $route.path.indexOf('/personal_center/judge') !== -1  }">
            <router-link to="/personal_center/judge">我是评委</router-link>
          </li>
          <li :class="{ active: $route.path.indexOf('/personal_center/account_settings') !== -1  }">
            <router-link to="/personal_center/account_settings"
            >账户设置
            </router-link
            >
          </li>
        </ul>
      </div>
      <!-- 按钮 -->
      <div class="btns">
        <div class="btn_item active">
          <a href="javascript:;" @click="to" >
            管理后台
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {};
  },
  created() {
  },
  methods: {
    // 报名
    to() {
      let href = 'http://120.78.79.8:8080/houtai/data_mining_laboratory/dist/#/login'
      if(process.env.VUE_APP_EVN === 'production'){
        href = 'http://manager.minerlab.cn'
      }
      window.open(href, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.personal_center_header {
  background-color: #ffffff;
  border-top: 1px solid #eeeeee;
  .fade-enter-active, .fade-leave-active {
    transition: opacity 2s
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */
  {
    opacity: 0
  }
  .hint {
    margin-top: 10px;
    font-size: 14px;
    color: red;
    /* @-moz-keyframes shimmer {*/
    /*   0% {*/
    /*     background-position: top left;*/
    /*   }*/
    /*   100% {*/
    /*     background-position: top right;*/
    /*   }*/
    /* }*/
    /* @-webkit-keyframes shimmer {*/
    /*   0% {*/
    /*     background-position: top left;*/
    /*   }*/
    /*   100% {*/
    /*     background-position: top right;*/
    /*   }*/
    /* }*/
    /* @-o-keyframes shimmer {*/
    /*   0% {*/
    /*     background-position: top left;*/
    /*   }*/
    /*   100% {*/
    /*     background-position: top right;*/
    /*   }*/
    /* }*/
    /* @keyframes shimmer {*/
    /*   0% {*/
    /*     background-position: top left;*/
    /*   }*/
    /*   100% {*/
    /*     background-position: top right;*/
    /*   }*/
    /* }*/
    /*.text{*/
    /*  font-size: 14px;*/
    /*  color: rgba(255, 255, 255, 0.1);*/
    /*  !* Old browsers *!*/
    /*  background: #ed8080;*/
    /*  !* FF3.6+ *!*/
    /*  background: -moz-linear-gradient(left, #ed8080 0%, #2a77d6 16%, #5eb524 32%, #eacd25 48%, #ed8080 64%, #2a77d6 80%, #5eb524 100%);*/
    /*  !* Chrome,Safari4+ *!*/
    /*  background: -webkit-gradient(linear, left top, right top, color-stop(0%, #ed8080), color-stop(16%, #2a77d6), color-stop(32%, #5eb524), color-stop(48%, #eacd25), color-stop(64%, #ed8080), color-stop(80%, #2a77d6), color-stop(100%, #5eb524));*/
    /*  !* Chrome10+,Safari5.1+ *!*/
    /*  background: -webkit-linear-gradient(left, #ed8080 0%, #2a77d6 16%, #5eb524 32%, #eacd25 48%, #ed8080 64%, #2a77d6 80%, #5eb524 100%);*/
    /*  !* Opera 11.10+ *!*/
    /*  background: -o-linear-gradient(left, #ed8080 0%, #2a77d6 16%, #5eb524 32%, #eacd25 48%, #ed8080 64%, #2a77d6 80%, #5eb524 100%);*/
    /*  !* IE10+ *!*/
    /*  background: -ms-linear-gradient(left, #ed8080 0%, #2a77d6 16%, #5eb524 32%, #eacd25 48%, #ed8080 64%, #2a77d6 80%, #5eb524 100%);*/
    /*  !* W3C *!*/
    /*  background: linear-gradient(to right, #ed8080 0%, #2a77d6 16%, #5eb524 32%, #eacd25 48%, #ed8080 64%, #2a77d6 80%, #5eb524 100%);*/
    /*  !* IE6-9 *!*/
    /*  !*filter: progid: DXImageTransform.Microsoft.Gradient(startColorstr='#ed8080', endColorstr='#5eb524', GradientType=1);*!*/
    /*  -webkit-background-size: 300% 300%;*/
    /*  -moz-background-size: 300% 300%;*/
    /*  background-size: 300% 300%;*/
    /*  -webkit-background-clip: text;*/
    /*  -moz-background-clip: text;*/
    /*  background-clip: text;*/
    /*  animation: shimmer infinite 3s linear;*/
    /*  -o-animation: shimmer infinite 3s linear;*/
    /*  -moz-animation: shimmer infinite 3s linear;*/
    /*  -webkit-animation: shimmer infinite 3s linear;*/
    /*  background-repeat: no-repeat;*/
    /*  background-position: top left;*/
    /*  background-color: #222;*/
    /*}*/
  }
  .main {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .main_l {
    position: relative;
    .tooltip {
      position: absolute;
      background-color: #464C59;
      height: 50px;
      bottom: -60px;
      left: 15px;
      z-index: 999;
      color: #fff;
      font-size: 14px;
      line-height: 50px;
      padding: 0 20px;
      box-shadow: 0px 4px 18px 0px rgba(74, 84, 105, 0.3);
      border-radius: 4px;
      i {
        cursor: pointer;
        font-size: 14px;
      }
    }
    .tooltip:before {
      position: absolute;
      content: '';
      width: 10px;
      height: 10px;
      background-color: #464C59;
      transform: rotate(45deg);
      top: -5px;
    }
    h2 {
      width: 133px;
      align-self: center;
      margin-right: 40px;
    }
    img {
      width: 100%;
    }
    ul {
      min-width: 300px;
      align-items: center;
    }
    li {
      margin-right: 40px;
      height: 56px;
      line-height: 56px;
      cursor: pointer;
      position: relative;
    }
    li > a {
      display: inline-block;
      width: 100%;
      height: 100%;
      color: #333333;
      font-size: 16px;
    }
    li:hover a {
      color: #2468F2;
    }
    li.active:hover a, li.active a {
      color: #2468F2;
    }
    li.active:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 2px;
      background-color: #2468F2;
      bottom: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
    }
  }
  .main_l,
  .main_l ul,
  .main_r,
  .search_box {
    display: flex;
    flex-wrap: nowrap;
  }
  .main_r {
    justify-content: space-between;
  }
  .main_r,
  .search_box {
    align-items: center;
  }
  //我要路演按钮
  .roadshow {
    width: 100px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    color: #ffffff;
    background-color: #ff733c;
    font-size: 14px;
    cursor: pointer;
  }
  .ml10 {
    margin-left: 10px !important;
  }
  /*.el-select .el-input {*/
  /*  width: 104px !important;*/
  /*}*/
  /*.el-input-group__append button.el-button,*/
  /*.el-input-group__append div.el-select .el-input__inner,*/
  /*.el-input-group__append div.el-select:hover .el-input__inner,*/
  /*.el-input-group__prepend button.el-button,*/
  /*.el-input-group__prepend div.el-select .el-input__inner,*/
  /*.el-input-group__prepend div.el-select:hover .el-input__inner {*/
  /*  text-align: center;*/
  /*}*/
  .btns {
    display: flex;
    align-items: center;
    .btn_item {
      width: 100px;
      height: 34px;
      line-height: 32px;
      text-align: center;
      font-size: 14px;
      cursor: pointer;
      margin-left: 12px;
      border: 1px solid $color-default;
      box-sizing: border-box;
      a {
        display: inline-block;
        width: 100%;
        height: 100%;
        color: $color-default;
      }
    }
    .btn_item.active, .btn_item:hover {
      background-color: $color-default;
      a {
        color: #ffffff;
      }
    }
  }
}
</style>
